var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.177,
    height: 23,
    viewBox: "0 0 35.177 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.357,2.875a2.389,2.389,0,0,1-.531,1.462,3.521,3.521,0,0,1-1.432,1.053l3.691,5.63,5.771-3.144A2.624,2.624,0,0,1,27.639,5.75c0-1.576,1.7-2.875,3.769-2.875s3.769,1.3,3.769,2.875a3.12,3.12,0,0,1-2.709,2.726l-2.317,9.733V23H5.025V18.208L2.709,8.476A3.12,3.12,0,0,1,0,5.75C0,4.174,1.7,2.875,3.769,2.875s3.769,1.3,3.769,2.875a2.306,2.306,0,0,1-.316,1.161,3.039,3.039,0,0,1-.9.965l5.771,3.144,3.692-5.63a2.879,2.879,0,0,1-1.964-2.516C13.819,1.3,15.522,0,17.588,0s3.769,1.3,3.769,2.875Zm-5.025,0c0,.539.549.958,1.256.958s1.256-.419,1.256-.958-.549-.958-1.256-.958S16.332,2.335,16.332,2.875ZM2.513,5.75c0,.539.549.958,1.256.958S5.025,6.29,5.025,5.75s-.549-.958-1.256-.958S2.513,5.21,2.513,5.75Zm27.639,0c0,.539.549.958,1.256.958s1.256-.419,1.256-.958-.549-.958-1.256-.958S30.151,5.21,30.151,5.75ZM13.7,12.878l-1.884.359L5.537,9.823,7.3,17.25H27.874l1.768-7.427L23.36,13.237l-1.884-.359-3.887-5.93ZM7.538,21.083h20.1V19.167H7.538Z",
    transform: "translate(0 0)",
    fill: "#373334"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown1);
export default __webpack_public_path__ + "static/media/crown1.f3f6920370afd840dd6b23b94f7b8151.svg";
export { ForwardRef as ReactComponent };